import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnauthorisedComponent } from 'src/app/auth/components/unauthorised.component';
import { LogoutComponent } from 'src/app/logout/components/logout.component';
import { withDefaultAppGuards } from 'src/app/shared/helpers/route-helper';
import { ErrorPageComponent } from './error/error-page.component';
import { AdminOrSupportGuard } from './shared/guards/admin-or-support.guard';
import { LogoutGuard } from './logout/logout.guard';
import { CanvasRendererComponent } from './canvas-renderer/canvas-renderer.component';
import { isCanvasRendererHost } from './canvas-renderer/canvas-renderer-host';

const routes: Routes = withDefaultAppGuards([
  {
    path: 'signin-oidc',
    redirectTo: '/home',
    data: { auth: false }
  },

  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { allowBusinessUsers: true }
  },

  {
    path: 'dashboards',
    loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
  },

  {
    path: 'pivot-studio',
    redirectTo: 'visuals',
  },

  {
    path: 'visuals',
    loadChildren: () => import('./pivot-studio/pivot-studio.module').then(m => m.PivotStudioModule)
  },

  {
    path: 'scheduler',
    loadChildren: () => import('./scheduler/scheduler.module').then(m => m.SchedulerModule)
  },

  {
    path: 'enterprise-insights',
    redirectTo: 'publisher',
  },
  
  {
    path: 'publisher',
    loadChildren: () => import('./enterprise-reporting/enterprise-reporting.module').then(m => m.EnterpriseReportingModule)
  },

  {
    path: 'admin',
    canActivate: [AdminOrSupportGuard],
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
  },

  {
    path: 'support',
    loadChildren: () => import('./support/support.module').then(m => m.SupportModule),
    data: { allowBusinessUsers: true }
  },

  {
    path: 'logout',
    component: LogoutComponent,
    data: { allowBusinessUsers: true, auth: false },
    canActivate: [LogoutGuard],
  },
 
  {
    path: 'unauthorized',
    component: UnauthorisedComponent,
    data: { auth: false }
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: { auth: false }
  },
  
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
    data: { auth: false }
  },
  {
    path: '**', 
    component: ErrorPageComponent,
    data: {
      auth: false,
      error: 'Page not found'
    }
  }
]);

const canvasRendererRoutes: Routes = [
  {
    path: 'canvas-renderer',
    component: CanvasRendererComponent,
    data: {
      auth: false,
      layout: 'noframe'
    }
  }
];


@NgModule({
  imports: [RouterModule.forRoot(
    isCanvasRendererHost ? canvasRendererRoutes : routes
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
